import { useEffect, useState } from 'react'

function detectMobileDevice(agent: string) {
  const mobileRegex = [
    /Android/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ]

  return mobileRegex.some((mobile) => agent.match(mobile))
}

const mobileContext = () => {
  // 화면 크기 상태
  const [isMobile, setIsMobile] = useState(false)

  // 화면 크기 추적
  useEffect(() => {
    setIsMobile(detectMobileDevice(navigator.userAgent))
  }, [])

  return isMobile
}

export default mobileContext
